import Image from 'next/image'
import styled from 'styled-components'
import footerImg5 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 5.png'
import footerImg10 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 10.png'
import footerImg13 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 13.png'
import footerImg14 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 14.png'
import footerImg15 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 15.png'
import footerImg16 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 16.png'
import footerImg17 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 17.png'
import footerImg18 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 18.png'
import footerImg19 from '../../../assets/ai-studio-landing/footer_dm/Google_AI_Studio_2025-12-06T00_24_50.650Z 19.png'

const SectionWrapper = styled.section`
  width: 100%;
  height: 620px;
  position: relative;
  background: black;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 500px;
  }
`

const ImagesGrid = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 1512px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 8px;
    top: -20px;
    left: -20px;
    width: calc(100% + 40px);
    height: calc(100% + 40px);
    transform: none;
    max-width: none;
  }
`

const GridImage = styled.div`
  position: absolute;
  width: 381px;
  height: 382px;
  border-radius: 30px;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 280px;
    height: 280px;
  }

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    left: 0 !important;
    top: 0 !important;

    /* Left column (1st, 4th, 7th) — shift down */
    &:nth-child(3n + 1) {
      top: 30px !important;
    }

    /* Right column (3rd, 6th, 9th) — shift up */
    &:nth-child(3n) {
      top: -30px !important;
    }
  }
`

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.53);
  z-index: 1;
`

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
  max-width: 900px;
  gap: 20px;
`

const Title = styled.h2`
  color: white;
  font-size: 48px;
  font-weight: 700;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const Subtitle = styled.p`
  color: white;
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  max-width: 700px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 322px;
  height: 50px;
  background: white;
  border-radius: 100px;
  color: black;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
  }
`

const gridImages = [
  { src: footerImg5, left: -66, top: 47 },
  { src: footerImg10, left: -66, top: 469 },
  { src: footerImg13, left: 355, top: -310 },
  { src: footerImg14, left: 355, top: 113 },
  { src: footerImg15, left: 355, top: 536 },
  { src: footerImg16, left: 776, top: -226 },
  { src: footerImg17, left: 776, top: 197 },
  { src: footerImg18, left: 1197, top: -163 },
  { src: footerImg19, left: 1197, top: 260 }
]

const StartDesigningSection = ({ onActionClick }) => {
  return (
    <SectionWrapper>
      <ImagesGrid>
        {gridImages.map((img, index) => (
          <GridImage
            key={index}
            style={{ left: `${img.left}px`, top: `${img.top}px` }}
          >
            <Image
              src={img.src}
              alt={`Design example ${index + 1}`}
              layout="fill"
              objectFit="cover"
            />
          </GridImage>
        ))}
      </ImagesGrid>
      <Overlay />
      <ContentWrapper>
        <Title>Start Designing with AI Interior Design</Title>
        <Subtitle>
          Create, edit, and refine real room designs with DecorMatters — the AI interior design app for real homes.
        </Subtitle>
        <ActionButton
          href="https://decormatters.app.link/WTHVetOFCMb"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download the App
        </ActionButton>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default StartDesigningSection
